// extracted by mini-css-extract-plugin
export default {"m":"SendFavourites_m__Q+xy5","button":"SendFavourites_button__O+Hnz","checkbox":"SendFavourites_checkbox__wlpFY"};